import { chunkArray } from '~/utils/chunkArray';

export type SelectedVoucherUser = { voucherUserId: string; voucherId: string; userId: string };

export function createVoucherUserBulkBatches(selected: Array<SelectedVoucherUser>, batchSize: number) {
  const byVoucher = new Map<string, Set<string>>();
  for (const row of selected) {
    const userIds = byVoucher.get(row.voucherId) ?? new Set<string>();
    userIds.add(row.userId);
    byVoucher.set(row.voucherId, userIds);
  }
  return [...byVoucher].flatMap(([voucherId, userIds]) =>
    chunkArray([...userIds], batchSize).map((page) => ({ voucherId, userIds: page })),
  );
}

/** Expiry updates address assignment IDs, including multiple assignments for the same user. */
export function createVoucherUserExpiryBatches(selected: Array<SelectedVoucherUser>, batchSize: number) {
  const ids = [...new Set(selected.map((row) => row.voucherUserId))];
  return chunkArray(ids, Math.min(500, Math.max(1, batchSize))).map((voucherUserIds) => ({
    voucherId: '',
    voucherUserIds,
  }));
}
